<template>
    <button
        class="apple-sign-in"
        type="button"
        @click.prevent.stop="signIn"
    >
        <img
            class="icon"
            src="@/assets/third-party/apple.svg"
        />

        <span class="label">
            {{ t('registration.apple_sign_in') }}
        </span>
    </button>
</template>

<script setup lang="ts">
import { nextTick, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useScriptTag } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

import { useCustomerRegistrationInputStore } from '@/composables/useCustomerRegistrationInput'
import { useAppleAppId } from '@/plugins/apple-sign-in-id copy'

const emit = defineEmits<{
    submit: []
    fail: []
    click: []
}>()

const clientId = useAppleAppId()
const { t } = useI18n()

const { appleSignInToken, names } = storeToRefs(
    useCustomerRegistrationInputStore()
)
const initialized = ref(false)

const signIn = async () => {
    emit('click')

    if (!initialized.value) {
        return
    }

    try {
        const data = await AppleID.auth.signIn()

        if (data.user) {
            names.value = `${data.user.name.firstName} ${data.user.name.lastName}`
        }

        appleSignInToken.value = data.authorization.id_token

        emit('submit')

        nextTick(() => (appleSignInToken.value = null))
    } catch {}
}

if (clientId) {
    useScriptTag(
        'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
        () => {
            if (import.meta.env.SSR) {
                return
            }

            initialized.value = true

            // eslint-disable-next-line no-restricted-globals
            const url = new URL(window.location.href)

            AppleID.auth.init({
                clientId,
                redirectURI: url.protocol + '//' + url.host + '/',
                scope: 'name email',
                usePopup: true,
            })
        },
        {
            async: true,
        }
    )
}
</script>

<style scoped lang="scss">
.apple-sign-in {
    position: relative;
    width: 100%;
    height: 40px;
    border-radius: 20px;
    border: 1px solid $slate;
    background-color: $white;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-family: $effra-font-stack;
    letter-spacing: 0.05em;
    font-size: 1rem;
    font-weight: 400;

    .icon {
        margin-bottom: 2px;
        margin-left: 13.5px;
        height: 18px;
    }

    .label {
        display: block;
        width: 100%;
        text-align: center;
    }
}
</style>
